import React, { useEffect, useState } from 'react';
// import './patientList.css'
import {
    Badge,
    Button,
    ButtonGroup,
    Card,
    Container,
    Form,
    Modal,
    Stack,
    Table,
} from 'react-bootstrap';
import edit from '../../Assets/Img/edit.png';
import view from '../../Assets/Img/eye.png';
import { useSelector } from 'react-redux';
import { useEmailListMutation } from './emailApi';
import AddEmail from './addEmail';
import { useTranslation } from 'react-i18next';
import { frenchFormatDate, toCamelCase } from '../../helper';
import LoadingComponent from '../LoadingComponent';
import ApproveModal from './approveModal';
import { getSecureItem } from "../../utils/secureStorage";
const EmailList = () => {
    const { t } = useTranslation();
    const emailData = useSelector((state) => state.email);
    const user = getSecureItem('UserData');
    const [loading, setLoading] = useState(true);
    const [emailList] = useEmailListMutation();
    console.log(user?.userType, 'user');

    useEffect(() => {
        if (loading) {
            emailList().then((data) => {
                setLoading(false);
            });
        }
    }, [loading]);

    const getEmailState = (status) => {
        let result;
        switch (status) {
            case 'Approve':
                result = { bg: 'success' };
                break;
            case 'Pending':
                result = { bg: 'warning' };
        }
        return result;
    };

    if (loading) {
        return <LoadingComponent />;
    }

    return (
        <>
            <Container fluid className="list_wrapper">
                <Stack direction="horizontal" gap={3} className="mb-3">
                    <div className="">
                        <h3>{t('patientEmailChangeList')}</h3>
                    </div>
                    <div className="ms-auto">
                        <AddEmail setLoading={setLoading} />
                    </div>
                </Stack>
                <Card>
                    <Card.Body className="table_outer">
                        <Table>
                            <thead>
                                <tr>
                                    <th>{t('patientNo')}</th>
                                    <th>{t('wrongEmail')}</th>
                                    <th>{t('correctEmail')}</th>
                                    <th>{t('date')}</th>
                                    {user?.userType == 'ADMIN' && (
                                        <th>{t('status')}</th>
                                    )}
                                    {user?.userType == 'ADMIN' ? (
                                        <th className="text-center">
                                            {t('actions')}
                                        </th>
                                    ) : (
                                        <th className="text-center">
                                            {t('status')}
                                        </th>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {emailData?.items &&
                                    emailData?.items.map((email, index) => (
                                        <tr key={index}>
                                            <td>{email.patientUniqueCode}</td>
                                            <td>{email.oldEmail}</td>
                                            <td>{email.newEmail}</td>
                                            <td>
                                                {frenchFormatDate(
                                                    email.submittedDate
                                                )}
                                            </td>
                                            <td>
                                                {email.statusEmail == 'Approve'
                                                    ? 'Approuvé'
                                                    : 'En cours de traitement'}
                                            </td>
                                            <td>
                                                <Stack
                                                    direction="horizontal"
                                                    gap={1}
                                                >
                                                    <div className="ms-auto">
                                                        {email.statusEmail !==
                                                        'Approve' ? (
                                                            <ButtonGroup>
                                                                <ApproveModal
                                                                    setLoading={
                                                                        setLoading
                                                                    }
                                                                    patientuniquecode={
                                                                        email.patientUniqueCode
                                                                    }
                                                                    newemail={
                                                                        email.newEmail
                                                                    }
                                                                />
                                                            </ButtonGroup>
                                                        ) : (
                                                            ''
                                                        )}
                                                    </div>
                                                </Stack>
                                            </td>
                                        </tr>
                                    ))}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            </Container>
        </>
    );
};

export default EmailList;
